import * as React from 'react'
import { LoadingIndicator } from '../../LoadingIndicator';
import axios from '../../services/index'

//This component allow admin to create a new training
export const AddTraining: React.FunctionComponent = (props) => {

    let addTrainingJSON: any = {}
    const [submitted, setSubmitted] = React.useState(false)


    const submitAddTraining= () => {

        let form_data = new FormData();

        for (let key in addTrainingJSON) {
            form_data.append(key, addTrainingJSON[key])
        }

        axios.post('https://LaurenceBrun.eu.pythonanywhere.com/admintrainingadd/', form_data,
        {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }
        )
        .then(function (response) {
            alert('Formation créée avec succès')
            window.location.reload()
        })
        .catch(function(erreur) {
            console.log(erreur.response)
            setSubmitted(false)
            alert("Une erreur est survenue ! Veuillez réessayer")
        })
    }

    const handleSubmit = (event: any) => {
        event.preventDefault()
        let isPriceOk = true
        if (event.target.title.value && event.target.description.value && event.target.price.value && event.target.videoPresentationLink.value && event.target.videoLink.value && event.target.pdfLink.value && event.target.facebookLink.value && event.target.googleFormLink.value && event.target.duration.value && event.target.pedagogicalMethods.value && event.target.objectives.value && event.target.detailledProgram.value && event.target.prerequisite.value){
            let price = event.target.price.value
            if (price.indexOf(',') >= 0) {
                price = price.replace(',', '.')
            }
            else if (price.indexOf('.') <= 0) {
                alert('Précisez les centimes sur le prix !')
                isPriceOk = false
            }
            else if (price.split('.')[1].length > 2) {
                alert('Trop de chiffres pour les centimes !')
                isPriceOk = false
            }
            
            if(isPriceOk) {
                price = parseFloat(price).toFixed(2)
            }

            if(isPriceOk){
                addTrainingJSON = {
                    "title": event.target.title.value,
                    "description": event.target.description.value,
                    "price": price,
                    "presentationVideoLink": event.target.videoPresentationLink.value,
                    "videoLink": event.target.videoLink.value,
                    "pdfLink": event.target.pdfLink.files[0],
                    "facebookLink": event.target.facebookLink.value,
                    "googleFormLink": event.target.googleFormLink.value,
                    "duration": event.target.duration.value,
                    "pedagogicalMethods": event.target.pedagogicalMethods.value,
                    "objectives": event.target.objectives.value,
                    "detailledProgram": event.target.detailledProgram.value,
                    "prerequisite": event.target.prerequisite.value,
                }
                setSubmitted(true)
                submitAddTraining()
            }
        }
        else{
            alert('Vous devez remplir tous les champs !')
        }
    }

    //Display loader during processing of requests
    const isLoading = () => {
        if (submitted) {
            return(
                <div className="Loading">
                    <div className="Loader"><LoadingIndicator /></div>
                </div>
            )
        }
    }

    return(
        <div className="Connect">
            {isLoading()}
            <h2>Ajout d'une formation</h2>
            <form onSubmit={handleSubmit}>
                <label>
                    <input type="text" name="title" placeholder="Titre" />
                </label><br />
                <label>
                    <input type="text" name="videoPresentationLink" placeholder="Url vidéo de présentation"/>
                </label><br />
                <label>
                    <input type="text" name="price" placeholder="Prix" />
                </label><br />
                <label>
                    <input type="text" name="videoLink" placeholder="Url vidéo de formation" />
                </label><br />
                <label>
                    <input type="text" name="facebookLink" placeholder="Url groupe facebook" />
                </label><br />
                <label>
                    <input type="text" name="googleFormLink" placeholder="Url du Google Form pour l'attestation" />
                </label><br />
                <label>
                    <textarea rows={5} cols={50}name="description" placeholder="Description" />                    
                </label><br />
                <label>
                    <textarea rows={5} cols={50}name="duration" placeholder="Durée de la formation" />                    
                </label><br />
                <label>
                    <textarea rows={5} cols={50}name="objectives" placeholder="Objectifs*" />                    
                </label><br />
                <label>
                    <textarea rows={5} cols={50}name="detailledProgram" placeholder="Programme détaillé*" />                    
                </label><br />
                <label> <span className="asPlaceholder">Méthodes pédagogiques* ** : </span>
                    <textarea rows={5} cols={50}name="pedagogicalMethods">Méthodes de pédagogie active permettant de vous rendre acteur de vos apprentissages.</textarea>                    
                </label><br />
                <label> <span className="asPlaceholder">Prérequis* ** : </span>
                    <textarea rows={5} cols={50}name="prerequisite">Aucun prérequis n'est nécessaire pour suivre ce module de formation.</textarea>                    
                </label><br />
                <label> <span className="asPlaceholder">PDF : </span>
                    <input type="file" name="pdfLink" />
                </label><br />
                <input type="submit" value="enregistrer" className="ConnectButton Connexion" />
            </form>
            <div>*: séparer les items par le symbole _ pour un retour à la ligne</div>
            <div>**: tu peux supprimer le texte prééxistant</div>
        </div>
    )
}